<script setup lang="ts">
  import { createFlatBaseColumns } from '@/utils/table.ts'
  import { type ChangelogEntry, type IopFormMessage, operationMapping } from '@/types/iop-form.js'
  import { computed } from 'vue'
  import { Modal, Table, UiButton } from '@logistiek-zonder-papier/lzp-library'

  const props = defineProps<{
    changelog: ChangelogEntry[] | null
    selectedRow: IopFormMessage | undefined
    isLoading: boolean
  }>()

  const show = defineModel<boolean>({ default: false, required: true })

  const changeLogColumns = computed(() =>
    createFlatBaseColumns(
      props.changelog || [],
      ['changedByOrganizationUuid', 'changedByOrganizationEnterpriseNumber', 'targetFormVersion'],
      {
        columnOrder: [
          'sourceFormVersion',
          'operation',
          'pdfFieldTitle',
          'previousValue',
          'currentValue',
          'changedOnTimestamp',
          'changedByOrganizationName',
        ],
        labelOverrides: {
          previousValue: 'Vorige waarde',
          currentValue: 'Huidige waarde',
          changedByOrganizationName: 'Veranderd door',
          changedByUser: 'Veranderd door',
          changedOnTimestamp: 'Tijd',
          pdfFieldTitle: 'Veld',
          sourceFormVersion: 'Versie',
          changedByVatNumber: 'Veranderd door (org nummer)',
          operation: 'Actie',
        },
      }
    )
  )
</script>

<template>
  <Modal v-if="props.selectedRow" v-model:show="show">
    <template #header>
      <h3>
        Veranderingen formulier {{ props.selectedRow.uuid }} (versie:
        {{ props.selectedRow.formVersion }})
      </h3>
    </template>
    <div v-if="props.isLoading" class="loading">Loading changelog...</div>
    <div v-else-if="props.changelog">
      <Table
        :rows="props.changelog"
        :columns="changeLogColumns"
        :configurable="true"
        configuration-storage-key="iopFormMessageChangeLogTable"
        row-key="id"
      >
        <template #cell-operation="{ row }">
          {{ operationMapping.get(row.operation) || row.operation }}
        </template>
      </Table>
    </div>
    <div v-else class="error">Failed to load changelog</div>
    <template #footer="{ close }">
      <UiButton @click="close" label="Sluiten" variant="default" />
    </template>
  </Modal>
</template>

<style scoped></style>
